import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Features from '../components/Features';
import WhyChooseUs from '../components/WhyChooseUs';
import ContactCTA from '../components/ContactCTA';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      <Services />
      <Features />
      <WhyChooseUs />
      {/* <ContactCTA /> */}
    </div>
  );
};

export default Home;
